import React from 'react';
import { Typography } from '@mui/material';
import type { KontrolaStatusResponse } from '../../../api/JsdhNotifikaceService/generated/models/Kontrola';

/** Popisek „převzato z: X“ u stavu prevzateho z jine kontroly (spec 6.2). */
const PrevzatoPopisek: React.FC<{ kontrola: KontrolaStatusResponse }> = ({ kontrola }) => {
    if (!kontrola.prevzatoZTypu) {
        return null;
    }
    return (
        <Typography variant="caption" color="text.secondary" display="block">
            převzato z: {kontrola.prevzatoZTypu.nazev}
        </Typography>
    );
};

export default PrevzatoPopisek;
